import React, { useState, useEffect, useContext } from "react";
import { useHistory } from "react-router-dom";
import Moment from "moment";
import { FiSearch } from "react-icons/fi";

import { Container, Content } from "./styles";

import VisaoGeral from "../../../components/VisaoGeralGerenciamento";

import api from "../../../services/api";

import SessionContext from "../../../contexts/sessionContext";

import { ProcessProps } from "../../../types/ProcessTypes";

function GerenicamentoDeProcessos() {
	const [searchTerm, setSearchTerm] = useState("");

	const [process, setProcess] = useState<ProcessProps[]>();

	const history = useHistory();

	const { user } = useContext(SessionContext);

	const ProcessComp = (process: ProcessProps) => {
		const handleTypistOneIn = async (id: number) => {
			await api.patch(
				`/data/process&id=${id}/defineTypistOne`,
				{
					user_id: user.id,
				},
			);

			history.push(`/consulta&id=${id}&place=1`);
		};

		const handleTypistTwoIn = async (id: number) => {
			await api.patch(
				`/data/process&id=${id}/defineTypistTwo`,
				{
					user_id: user.id,
				},
			);

			history.push(`/consulta&id=${id}&place=2`);
		};

		return (
			<tr className='process-comp'>
				<td id='prop-name' title={process.proponent_name.toUpperCase()}>
					<p>{process.proponent_name.toLowerCase()}</p>
				</td>
				<td>{process.cpf}</td>
				<td>{Moment(process.createdAt).format("DD/MM/YYYY")}</td>
				<td>{Moment(process.createdAt).format("HH:mm")}</td>
				<td>
					{process.typist_one_id === null ? (
						<button
							className='get-in-form'
							onClick={() => handleTypistOneIn(process.id)}
						>
							ENTRAR
						</button>
					) : process.typist_one_id === user.id ? (
						<button
							className='get-in-form'
							onClick={() =>
								history.push(
									`/consulta&id=${process.id}&place=1`,
								)
							}
						>
							Continuar
						</button>
					) : (
						<p>{process.typist_one?.name}</p>
					)}
				</td>
				<td>
					{
						//Não tem digitador 1 nem 2
						process.typist_one_id === null &&
						process.typist_two_id === null ? (
							<button>Entrar</button>
						) : //Tem digitador 1 e não tem dois
						process.typist_one_id !== null &&
						  process.typist_two_id === null ? (
							<button
								className='get-in-form'
								onClick={() => handleTypistTwoIn(process.id)}
							>
								ENTRAR
							</button>
						) : // Continuar como digitador 2
						process.typist_two_id === user.id ? (
							<button
								className='get-in-form'
								onClick={() =>
									history.push(
										`/consulta&id=${process.id}&place=2`,
									)
								}
							>
								Continuar
							</button>
						) : (
							<p>{process?.typist_two?.name}</p>
						)
					}
				</td>
				<td>
					{process.analist == null ? (
						""
					) : (
						<p>{process.analist.name}</p>
					)}
				</td>
				<td>
					{process.status === 0
						? "Aguardando análise"
						: process.status === 1
						? "Pendente"
						: process.status === 2
						? "Em progresso"
						: process.status === 3
						? "Aprovado"
						: process.status === 4
						? "Reprovado"
						: process.status === 5
						? "Com divergência"
						: process.status === 6
						? "Aguardando digitador"
						: null}
				</td>
			</tr>
		);
	};

	useEffect(() => {
		const process_data = async () => {
			try {
				const { data } = await api.get("/data/process");
				if (data.data) setProcess(data.data);
			} catch (error) {
				return error;
			}
		};

		process_data();
	}, []);

	return (
		<Container>
			<Content>
				<div className='header'>
					<div className='user-info'>
						<div>
							<p className='header-text' id='func'>
								Digitador
							</p>
							<p className='header-text' id='name'>
								{user.name}
							</p>
						</div>

						<div className='Search-container'>
							<FiSearch />
							<input
								type='text'
								id='searchBox'
								placeholder='Buscar por nome ou cpf...'
								onChange={(e) => setSearchTerm(e.target.value)}
							/>
						</div>
					</div>
					<div className='header-manager'>
						<VisaoGeral />
					</div>
				</div>
				<div className='process-manager'>
					<div>
						<p id='keep-title'>Processos</p>
					</div>
					<table className='table-wrapper'>
						<tr>
							<th>Nome do Proponente</th>
							<th>CPF</th>
							<th>Data</th>
							<th>Hora</th>
							<th>Digitador 1</th>
							<th>Digitador 2</th>
							<th>Analista</th>
							<th>Status</th>
						</tr>

						{process ? (
							process
								.filter((item) => {
									if (searchTerm === "") {
										return item;
									} else if (
										item.proponent_name
											.toLowerCase()
											.includes(searchTerm.toLowerCase())
									) {
										return item;
									} else if (item.cpf.includes(searchTerm)) {
										return item;
									}
								})
								.filter((process) => {
									if (
										process.status === 6 ||
										process.status === 2
									) {
										return process;
									}
								})
								.map((i) => {
									return (
										<ProcessComp
											proponent_name={i.proponent_name}
											id={i.id}
											cpf={i.cpf}
											createdAt={i.createdAt}
											analist={i.analist}
											status={i.status}
											typist_one={i.typist_one}
											typist_one_id={i.typist_one_id}
											typist_two={i.typist_two}
											typist_two_id={i.typist_two_id}
											key={i.id}
											infos={i.infos}
											infos_two={i.infos}
										/>
									);
								})
						) : (
							''
						)}
					</table>
				</div>
			</Content>
		</Container>
	);
}

export default GerenicamentoDeProcessos;
